import React, { createContext, useLayoutEffect } from 'react'
import {
  AuthService,
  clearUserCookies,
  getRefreshToken
} from './authService.jsx'
import axios from 'axios'
import { Cookies } from 'react-cookie'
import { API } from '../../api'

export const AuthContext = createContext()
const cookies = new Cookies()

export function AuthProvider(props) {
  const _userIsAuthenticated = AuthService.getAccessToken()

  useLayoutEffect(() => {
    const reqInterceptor = API.interceptors.request.use(function (config) {
      config.headers.Authorization = _userIsAuthenticated
        ? `Bearer ${_userIsAuthenticated}`
        : config.headers.Authorization

      return config
    })

    return () => {
      axios.interceptors.request.eject(reqInterceptor)
    }
  }, [_userIsAuthenticated])

  useLayoutEffect(() => {
    const refreshInterceptor = API.interceptors.response.use(
      response => response,
      async error => {
        const originalReq = error.config

        // Check if the error is a 401 || 403
        if (
          error.response &&
          (error.response.status === 401 || error.response.status === 403) &&
          !originalReq._retry &&
          error.config.url !== '/login'
        ) {
          originalReq._retry = true

          try {
            //Use the refresh token saved from the login request
            //Stored in cookies
            const refreshToken = getRefreshToken()

            //Check if the token is valid
            const res = await axios({
              method: 'post',
              url: `${process.env.REACT_APP_SERVER_URL}/refresh-token`,
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${refreshToken}`
              },
              data: {
                refreshToken
              }
            })

            const newToken = res.data?.message?.token

            //Set the new token if it is valid
            originalReq.headers.Authorization = `Bearer ${newToken}`
            cookies.set('jwt_token', newToken)
            window.location.replace('/')
            return API(originalReq)
          } catch (refreshError) {
            //Redirect to login page if the token is not working
            clearUserCookies()
            AuthService.signinRedirect()
            return Promise.reject(refreshError)
          }
        }

        return Promise.reject(error)
      }
    )

    return () => {
      axios.interceptors.response.eject(refreshInterceptor)
    }
  }, [])

  return (
    <AuthContext.Provider value={{ ...AuthService }}>
      {props.children}
    </AuthContext.Provider>
  )
}
